/**
 * 将上传返回的绝对地址规范为相对路径，便于入库与跨环境展示
 */
export function normalizeFileUrl(url) {
  if (!url) return ''
  // TOS/OSS 等对象存储返回的是可访问绝对地址，不能截成 pathname
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/')) return url
  try {
    const parsed = new URL(url)
    return parsed.pathname
  } catch (e) {
    return url
  }
}

/**
 * 将相对路径转为可访问的完整地址（开发环境走 devServer 代理）
 */
export function resolveFileUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith('/uploads/')) {
    return `/files/${url.slice('/uploads/'.length)}`
  }
  if (url.startsWith('/')) return url
  return `/files/${url.replace(/^\/+/, '')}`
}

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i

/** 作品封面缩略图：优先 coverUrl */
export function workCoverThumb(work) {
  if (!work) return ''
  if (work.coverUrl) return resolveFileUrl(work.coverUrl)
  const media = work.videoUrl || ''
  if (IMAGE_EXT.test(media)) return resolveFileUrl(media)
  return ''
}
